export default __webpack_public_path__ + "static/execs-bf53a8c66e5e7fdc8934ab8777f36b33.jpg";